import Screen from '../../js/lib/screen';
// Super Simple trigger/target
// .js-trigger need the class of the target as data-target
const trigger = document.querySelectorAll('.js-trigger');
const screen = new Screen();
if (trigger.length > 0) {
	const toggleTarget = (event) => {
		const elementToOpen = document.querySelector(event.currentTarget.getAttribute('data-target'));
		if (elementToOpen.getAttribute('data-open') === "true") {
			// Close
			screen.turnScreenOff();
			event.currentTarget.removeAttribute('data-on');
			elementToOpen.removeAttribute('data-open');
		} else {
			// Open
			screen.turnScreenOn();
			event.currentTarget.setAttribute('data-on', true);
			elementToOpen.setAttribute('data-open', true);
			if (elementToOpen.querySelector('input')) {
				elementToOpen.querySelector('input').focus();
			}
		}
	}
	const closeTarget = () => {
		for (var i = 0; i < trigger.length; i++) {
			const target = document.querySelector(trigger[i].getAttribute('data-target'));
			trigger[i].removeAttribute('data-on');
			target.removeAttribute('data-open');

		}
		screen.turnScreenOff();
	}
	for (var i = 0; i < trigger.length; i++) {
		trigger[i].addEventListener('click', (event) => {
			toggleTarget(event);
		});
	}
	screen.screenElement.addEventListener('click', () => {
		closeTarget();
	}, false);
}


// WEBPACK FOOTER //
// ./modules/showhide.js